// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cy3gC","label":"styles_label__F7vU6","icon":"styles_icon__x0NDJ"};